module.exports = __webpack_public_path__ + "assets/beta-bsc.cb1283f1.svg";